import { useState } from "react";
import { Document, Page } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import useResizeObserver from "use-resize-observer";

interface PdfViewerProps {
	pdfUrl: string;
}

export default function PdfViewer(props: PdfViewerProps) {
	const [numPages, setNumPages] = useState<number>();

	function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
		setNumPages(numPages);
	}

	const { ref, width = 1 } = useResizeObserver<HTMLDivElement>();

	return (
		<div className="w-100">
			<div ref={ref} className="w-100 d-flex justify-content-center">
				<Document
					loading="PDF wird geladen..."
					className="user-select-text"
					file={props.pdfUrl}
					onLoadSuccess={onDocumentLoadSuccess}>
					{Array.from(new Array(numPages), (_, index) => (
						<Page loading="" className="mb-2" key={index} pageNumber={index + 1} width={width} />
					))}
				</Document>
			</div>
		</div>
	);
}
